import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
// import CustomAlert from "../../../../components/Alert/CustomAlert";
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetJournalsUnPostedList } from '../../../../store/Finance/Journals/postingJournalsSlice';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {type  JournalsUnPostModels } from '../../../../store/Finance/Journals/JournalsModels';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import ViewSingleJournals from './ViewSingleJournals';
import NtxTable from '../../../../components/DataTable/NtxTable';

const UnPostedJournalsList = () => {
  const [date, setDate] = useState('');
  const [search, setSearch] = useState('');
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [SingleJournals, setSingelJournals] = useState<JournalsUnPostModels>(
    {} as JournalsUnPostModels
  );
  const [MultiJournals, setMultiJournals] = useState<JournalsUnPostModels[]>([]);
  const { JournalsUnPostedList } = useAppSelector((state) => state.PostingJournals);

  const filteredSearch = JournalsUnPostedList?.slice()?.filter((item) => {
    const itemDate = new Date(item.glDate);
    const searchDate = new Date(date);
    return (
      itemDate < searchDate && (item.name?.includes(search) || item.description?.includes(search))
    );
  });

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setDate(formattedDate);
  }, []);

  useEffect(() => {
    dispatch(GetJournalsUnPostedList());
  }, []);

  const handleOpenAddPayment = () => {
    const modal: HTMLElement | null = document.getElementById('modalِInstallmentPayment');
    // Open the modal using Bootstrap's modal method
    if (modal) {
      const bootstrapModal = new Modal(modal);
      bootstrapModal.show();
    }
  };

  const handleCheckboxChange = (row: JournalsUnPostModels) => {
    setMultiJournals((prevSelectedRows) => {
      const isSelected = prevSelectedRows?.some((item) => item.id === row.id);
      if (isSelected) {
        return prevSelectedRows?.filter((item) => item.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  const handleOpenViewSingleJournals = async (item: JournalsUnPostModels) => {
    const modal: HTMLElement | null = document.getElementById('modalSingelPost');
    await setSingelJournals({} as JournalsUnPostModels);
    await setSingelJournals(item);
    if (modal) {
      const bootstrapModal = new Modal(modal);
      bootstrapModal.show();
    }
  };

  //_____________________
  const columns = [
    { title: '', key: 'check' },
    { title: 'رقم القيـد', key: 'no' },
    { title: 'التاريـخ', key: 'date' },
    // { title: 'المصدر', key: 'source' },
    { title: 'التصنيف', key: 'catogory' },
    { title: 'البيان', key: 'name' },
    { title: 'حالة القيد', key: 'status' },
    // { title: 'دائن', key: 'Cr' },
    // { title: 'مديـن', key: 'Dr' },
    { title: '', key: 'action', className: 'text-end', sortable: false },
  ];

  const tableData = filteredSearch?.map((item, idx) => {
    let rowClass;

    // تحديد الشارة بناءً على قيمة `status`
    const statusBadge = () => {
      switch (item.status) {
        case 'U':
          return (
            <span className="badge bg-danger ">
              <i className="fas fa-times-circle me-1"></i> قيد غير مرحل
            </span>
          );
        case 'T':
          return (
            <span className="badge bg-warning ">
              <i className="fas fa-clock me-1"></i> حفظ مؤقت
            </span>
          );
        case 'P':
          return (
            <span className="badge bg-success ">
              <i className="fas fa-check-circle me-1"></i> قيد مرحل
            </span>
          );
        default:
          return '.';
        // return <span className="badge bg-secondary">غير معروف</span>;
      }
    };

    return {
      check: (
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id={`checkbox-${item.id}`}
            checked={MultiJournals?.some((row) => row.id === item.id)}
            //   onChange={(e) => e.stopPropagation()}
            onChange={() => handleCheckboxChange(item)}
          />
        </div>
      ),
      no: ++idx,
      date: item.glDate,
      source: i18n.language === 'en' ? item.jeSourceName : item.jeSourceName2,
      catogory: i18n.language === 'en' ? item.jeCategoryName : item.jeCategoryName2,
      name: i18n.language === 'en' ? item.name : item.name2,
      // Cr: item.accountedCr,
      //  Dr: item.accountedDr,
      status: statusBadge(),
      action: (
        <Link
          to=""
          className="btn btn-sm btn-outline-theme"
          onClick={() => handleOpenViewSingleJournals(item)}>
          ترحيل
        </Link>
      ),
    };
  });
  //_____________________
  var BcrumbList = [
    {
      name: t('Home'),
      link: ':moduleHome',
    },
    {
      name: 'ترحيــل القيود',
      link: null,
    },
  ];

  return (
    <div>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName={'ترحيــل القيود'} />

      <Card>
        <CardBody>
          <div className="row ">
            <div className="col-lg-5">
              <div className="input-group flex-nowrap">
                <span className="input-group-text fw-bold">{t('Search')}</span>
                <div className="input-group">
                  <div className="flex-fill position-relative">
                    <div className="input-group border-0 ">
                      <div
                        className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                         >
                        <i className="fa fa-search opacity-5 text-theme"></i>
                      </div>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control ps-35px"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="input-group flex-nowrap">
                <span className="input-group-text fw-bold">{t('Date')}</span>
                <Form.Control
                  className="form-control"
                  type="date"
                  value={date}
                  onChange={(e) => {
                    const selectedDate = e.target.value;
                    // Prevent clearing the date
                    if (selectedDate !== '') {
                      setDate(selectedDate);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-lg-2 text-end">
              <Link
                to=""
                className={`btn w-100 me-1  ${
                  MultiJournals?.length === 0 ? ' disabled btn-outline-theme ' : ' btn-theme '
                }`}
                onClick={() => handleOpenAddPayment()}>
                <i className="far fa-lg fa-fw me-2 fa-money-bill-alt"></i>
                ترحيل
              </Link>
            </div>
          </div>

          {/* <div className="table-responsive">
            <table className="table table-hover text-nowrap">
              <thead className="table-dark">
                <tr>
                  <th className="pt-2 pb-2"></th>
                  <th className="pt-2 pb-2">{t('اسم القيـد')}</th>
                  <th className="pt-2 pb-2">{t('العملة')}</th>
                  <th className="pt-2 pb-2">{t('Debt')}</th>
                  <th className="pt-2 pb-2">{t('Credit')}</th>
                  <th className="pt-2 pb-2">{t('الحالة')}</th>
                  <th className="pt-2 pb-2"></th>
                </tr>
              </thead>
              <tbody>
                {currentData?.map((item) => (
                  <tr key={item.id}>
                    <td className="w-10px align-middle">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${item.id}`}
                          checked={MultiJournals?.some((row) => row.id === item.id)}
                          onChange={() => handleCheckboxChange(item)}
                        />
                      </div>
                    </td>

                    <td className="align-middle"> {item.name} </td>
                    <td className="align-middle"> {item.currencyCode} </td>
                    <td className="align-middle"> {item.accountedDr} </td>
                    <td className="align-middle"> {item.accountedCr} </td>
                    <td className="align-middle"> {item.status} </td>
                    <td className="align-middle">
                      <Link
                        to=""
                        className="btn me-1 btn-theme"
                        onClick={() => handleOpenViewSingleJournals(item)}>
                        ترحيل
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            filteredData={filteredSearch}
            dataPerPage={dataPerPage}
            handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
            currentPage={currentPage}
          /> */}

          <NtxTable
            data={tableData || []}
            columns={columns}
            dataPerPage={10}
            theadClass=""
            tableClass="table text-nowrap table-hover "
          />
        </CardBody>
      </Card>

      <ModalComponent id="modalSingelPost" title="ترحيــل قيد">
        {Object.keys(SingleJournals)?.length > 0 && <ViewSingleJournals Journal={SingleJournals} />}
      </ModalComponent>
    </div>
  );
};

export default UnPostedJournalsList;
